<ng-template #cardTemplate let-ticket="ticket">
    <div class="generated-card" [style.width.px]="cardWidth" [style.height.px]="cardHeight">
        <div class="card-image-background">
            <img [src]="card_image" alt="Generated card background" (load)="onCardImageLoad()"
                (error)="onImageError($event)">
        </div>

        <div class="qr-details" *ngIf="content !== 'no'" [style.top.px]="cardY" [style.left.px]="cardX"
            [style.color]="color">
            <div class="card-body">
                <div class="qr-container" [ngClass]="{
                    'horizontal-layout': layout === 'horizontal',
                    'vertical-layout': layout === 'vertical'
                }" [style.font-size.px]="fontSize">
                    <div class="qr-box" [style.width.px]="qrWidth" [style.height.px]="qrHeight">
                        <canvas *ngIf="scanType === 'qrcode'" #qrcodeCanvas class="qr-canvas" [style.width.px]="qrWidth"
                            [style.height.px]="qrHeight"></canvas>

                        <div *ngIf="scanType === 'barcode'" class="barcode-fallback" [style.width.px]="qrWidth"
                            [style.height.px]="qrHeight">
                            <div class="barcode-lines"></div>
                            <div class="barcode-text">{{ getBarcodeValue(ticket) }}</div>
                        </div>
                    </div>

                    <div class="info-box">
                        <div *ngFor="let field of getDisplayEntries(ticket)" [class.name]="isNameField(field.label)">
                            <span class="label">{{ field.label }}:</span> {{ field.value }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-strip" *ngIf="companyAd === 'on'" [style.font-size.px]="footerFontSize"
            [style.padding]="footerPaddingY + 'px 0'">
            {{ companyAdText }}
        </div>
    </div>
</ng-template>

<div class="print-sheet" [class.multiple]="ticket_print === 'multiple'">
    <ng-container *ngIf="ticket_print === 'single'">
        <ng-container *ngTemplateOutlet="cardTemplate; context: { ticket: null }"></ng-container>
    </ng-container>

    <ng-container *ngIf="ticket_print === 'multiple'">
        <ng-container *ngFor="let ticket of ticketCards">
            <ng-container *ngTemplateOutlet="cardTemplate; context: { ticket: ticket }"></ng-container>
        </ng-container>
    </ng-container>
</div>
